module.exports = __webpack_public_path__ + "static/scene-digital-3-905eb96c466410067d05bade0197ce99.png";